import { Link } from "react-router-dom";
import { Logo } from "@/components/shared";

const cols = [
  ["Product", [["Features", "/features"], ["Pricing", "/pricing"], ["Security", "/security"], ["Proxmox Backup", "/proxmox-backup"], ["MSP", "/msp"]]],
  ["Resources", [["How It Works", "/how-it-works"], ["Documentation", "/docs"], ["Status", "/status"], ["Contact", "/contact"]]],
  ["Legal", [["Terms of Service", "/legal/terms"], ["Privacy Policy", "/legal/privacy"], ["Acceptable Use", "/legal/aup"], ["SLA", "/legal/sla"]]],
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-800/80 bg-[#06080D]">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <Logo />
            <p className="mt-4 max-w-xs text-sm text-slate-500">Offsite Proxmox backups in minutes. Secure managed Proxmox Backup Server in the cloud — no second datacenter required.</p>
          </div>
          {cols.map(([title, items]) => (
            <div key={title}>
              <div className="mb-3 text-xs font-semibold uppercase tracking-widest text-slate-400">{title}</div>
              <ul className="space-y-2">
                {items.map(([l, h]) => (
                  <li key={h}><Link to={h} className="text-sm text-slate-500 hover:text-cyan-300">{l}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 border-t border-slate-800 pt-6 text-xs text-slate-600">
          <p>© {new Date().getFullYear()} ZettaKeep. All rights reserved.</p>
          <p className="mt-2 max-w-3xl">ZettaKeep is an independent product and is not affiliated with, endorsed by, or sponsored by Proxmox Server Solutions GmbH. “Proxmox”, “Proxmox VE” and “Proxmox Backup Server” are trademarks of their respective owners. ZettaKeep is compatible with Proxmox VE and Proxmox Backup Server.</p>
        </div>
      </div>
    </footer>
  );
}
